// @ts-nocheck
import * as React from 'react';
import styled from 'styled-components';
import T from 'aegisv2/Text';
import { Mutation } from '@apollo/client/react/components';
import Heart2 from 'crehana-icons/Heart2';

import { useMe } from 'Jsx/ContextApis/AuthContext';
import { EVENTS } from 'Jsx/ResourceDetail/constants';
import { secondaryMain, primaryColor } from '@crehana/ui/dist/styles/colors';
import ResourceLikeMutation from '../graphql/ResourceLikeMutation.graphql';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (min-width: 1024px) {
    flex-direction: row;
  }
  .likes {
    display: flex;
    margin: 0 15px;
  }
  .likesText {
    display: none;
    @media (min-width: 1024px) {
      display: inline-block;
      opacity: ${({ linkSelected }) => (linkSelected ? 1 : 0)};
      transition: all ease 0.3s;
    }
  }
  .heart {
    cursor: pointer;
    &:hover {
      path {
        fill: ${secondaryMain};
        transition: all ease-in-out 0.3s;
      }
    }
  }
`;

type LikeProps = {
  resourceId: number;
  category: string;
  likes: number;
  isLiked: boolean;
};

type LikeMutationVariables = {
  category: string;
  resourceId: number;
};

type LikeMutationData = {
  success: boolean;
  isLiked: boolean;
};

const Like = ({ resourceId, category, likes, isLiked }: LikeProps) => {
  const { me: user } = useMe();
  const [currentLikes, setLikes] = React.useState(likes);
  const [isLikedState, setLiked] = React.useState(isLiked);

  return (
    <Mutation<LikeMutationData, LikeMutationVariables>
      mutation={ResourceLikeMutation}
      variables={{ category, resourceId }}
    >
      {resourceLikeToggle => (
        <Wrapper linkSelected={likes + 1 === currentLikes || isLikedState}>
          <button
            type="button"
            className="heart"
            onClick={() => {
              if (!user) {
                window.showLoginModal();
              }
              if (user) {
                setLiked(!isLikedState);
                if (likes + 1 === currentLikes || isLikedState) {
                  setLikes(currentLikes - 1);
                  resourceLikeToggle();
                } else {
                  setLikes(currentLikes + 1);
                  resourceLikeToggle();
                }
              }
            }}
          >
            <Heart2
              size={30}
              color={
                likes + 1 === currentLikes || isLikedState
                  ? secondaryMain
                  : primaryColor
              }
            />
          </button>
          <T className="likes">{currentLikes}</T>
          <T className="likesText">¡Gracias!</T>
        </Wrapper>
      )}
    </Mutation>
  );
};

export default Like;
